import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { RxAuthProvider, useRx } from "@/context/AuthContext";
import { MarketProvider } from "@/context/MarketContext";
import AppShell from "@/components/layout/AppShell";
import Landing from "@/pages/Landing";
import { DemoLoginPage, SignInPage, SignUpPage } from "@/pages/AuthPages";
import Dashboard from "@/pages/Dashboard";
import SegmentPage from "@/pages/SegmentPage";
import { LiquidOptionsPage, NewsPage } from "@/pages/MarketPages";
import PerformancePage from "@/pages/PerformancePage";
import RiskCalculatorPage from "@/pages/RiskCalculatorPage";
import { PricingPage, ReferralPage } from "@/pages/AccountPages";
import ProDesk from "@/pages/ProDesk";
import ImmersivePage from "@/pages/ImmersivePage";
import PublicPricing from "@/pages/PublicPricing";

function Protected({ children }) {
  const { ready, authed } = useRx();
  if (!ready) return <div className="min-h-screen bg-[#050505]" />;
  if (!authed) return <Navigate to="/sign-in" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ClerkAuthProvider>
          <RxAuthProvider>
            <MarketProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
                <Route path="/demo" element={<DemoLoginPage />} />
                <Route path="/pricing" element={<PublicPricing />} />
                <Route path="/app" element={<Protected><AppShell /></Protected>}>
                  <Route index element={<Dashboard />} />
                  <Route path="liquid-options" element={<LiquidOptionsPage />} />
                  <Route path="news" element={<NewsPage />} />
                  <Route path="performance" element={<PerformancePage />} />
                  <Route path="tools" element={<RiskCalculatorPage />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="referral" element={<ReferralPage />} />
                  <Route path="pro-desk" element={<ProDesk />} />
                  <Route path="immersive" element={<ImmersivePage />} />
                  <Route path=":segment" element={<SegmentPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </MarketProvider>
          </RxAuthProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
